import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';
export const useAppNotificationService = () => {
    const store = useStore();
    const axios = useAxios();

    const url = store.state.apiUrl;

    const getCourseOrgTree = async (id: number): Promise<any> => {
        const res = await axios.get(`${url}/course-org/tree/${id}`);
        return res.data;
    };

    return {
        getCourseOrgTree,
    };
};
